var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M540 856q17 0 28.5-11.5T580 816q0-17-11.5-28.5T540 776q-17 0-28.5 11.5T500 816q0 17 11.5 28.5T540 856Zm140 0q17 0 28.5-11.5T720 816q0-17-11.5-28.5T680 776q-17 0-28.5 11.5T640 816q0 17 11.5 28.5T680 856ZM120 626V236q0-24 18-42t42-18h600q24 0 42 18t18 42v390h-60V236H180v390h-60Zm60 60v230h600V686H180Zm0 290q-24 0-42-18t-18-42V626h720v290q0 24-18 42t-42 18H180Zm0-350h600-600Zm0 60h600-600Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackend);
export default __webpack_public_path__ + "static/media/backend.a5cf241f7fd2842e29d7259c59d92cce.svg";
export { ForwardRef as ReactComponent };